import chain from "./chain";
import curry from "./curry";
import map from "./map";
import zipObj from "./zipObj";

const objFromListWith = curry((fn, _list) => chain(zipObj, map(fn))(_list));

export default objFromListWith;
